var ButtonApi_1;
import { __awaiter, __decorate } from "tslib";
import { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import DataLayer from '@slickdeals/blueprint-twig/javascript/utilities/dataLayer';
export const name = 'ButtonApi';
let ButtonApi = ButtonApi_1 = class ButtonApi {
    // eslint-disable-next-line class-methods-use-this
    trackDealDetailsView() {
        return __awaiter(this, void 0, void 0, function* () {
            const product = yield ButtonApi_1.getProduct();
            if (!product) {
                return;
            }
            ButtonApi_1.safeCall('setPageSmsCampaigningTag', product.primaryCategory);
            ButtonApi_1.safeCall('reportProductView', {
                categories: product.categories,
            });
        });
    }
    // eslint-disable-next-line class-methods-use-this
    trackDealDetailsOutclick() {
        return __awaiter(this, void 0, void 0, function* () {
            const product = yield ButtonApi_1.getProduct();
            if (!product) {
                return;
            }
            ButtonApi_1.safeCall('reportEvent', 'onsite', {
                action: 'outclick',
                categories: product.categories,
                extra: Object.assign({ type: 'deal' }, product),
            });
        });
    }
    /**
     * Pull deal data from dataLayer.product
     */
    static getProduct() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const product = yield DataLayer.get('product');
                const categoryPaths = (product.categoryPaths || []);
                // Find path with most nodes, preferring earlier entries in categoryPaths
                let categories = [];
                categoryPaths.forEach((path) => {
                    const nodes = path.split('>').map(node => node.trim());
                    if (nodes.length > categories.length) {
                        categories = [...nodes];
                    }
                });
                return {
                    categories,
                    threadId: product.threadId && product.threadId.toString(),
                    title: product.title,
                    primaryCategory: product.primaryCategory,
                    subCategory: product.subCategory,
                    store: product.store,
                    storeId: product.storeId,
                    brand: product.brand,
                    forumId: product.forumId && product.forumId.toString(),
                    isExpired: product.isExpiredDeal === 'Yes',
                    hoursSinceCreated: product.hoursSinceCreated,
                };
            }
            catch (e) {
                Logger.warn(`ButtonApi DataLayer error: ${e.message}`);
                return null;
            }
        });
    }
    /**
     * Safe proxy for bttnio() function
     */
    static safeCall(...args) {
        try {
            window.bttnio(...args);
        }
        catch (e) {
            /**
             * We've struggled to find ways to disable Button's popups in certain environments (staging, coupons subdomain, etc)
             * so we only include Button's pixel in prod with `slickdeals.net` domain filtering.
             * Therefore, we force error logging in prod here to help test and diagnose any issues.
             */
            Logger.error(`ButtonApi error: ${e.message}`, true);
        }
    }
};
ButtonApi = ButtonApi_1 = __decorate([
    injectable({ key: name, scope: InjectorScope.Singleton })
], ButtonApi);
export default ButtonApi;
